import React from 'react';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { Router } from 'react-router-dom';
import { authenticate } from 'modules/account';
import httpService from './services/httpService';

import configureStore from './configureStore';
import Routes from './Routes';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

httpService.setupInterceptors(store, history);
// Check if user is authenticated when first loading/refreshing browser and sets redux state
store.dispatch(authenticate());


export default () => (
  <Provider store={store}>
    <Router history={history}>
      <Routes />
    </Router>
  </Provider>
);
